import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Stack from "@mui/material/Stack";
import {AppBar, DialogTitle} from "@mui/material";
import React, {Fragment, useState} from "react";
import Paper from "@mui/material/Paper";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import {s_char} from "../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import CharRace from "./CharRace";
import CharVisible from "./CharVisible";
import CharNSC from "./CharNSC";
import updChar from "../_sig_api/updChar";
import {s_app_sl} from "../_signals/s_app";
import {s_char_bewusstlos, s_char_tot} from "../_signals/s_char_calc";
import Container from "@mui/material/Container";

function CharName() {

    useSignals();

    const [nameOpen, setNameOpen] = useState(false);
    const [newName, setNewName] = useState('');
    const [newPName, setNewPName] = useState('');

    const sl = s_app_sl.value;

    const handleNameOpen = () => {
        const name = s_char.value.name;
        const pname = s_char.value.pname;

        setNewName(name);
        setNewPName(pname);
        setNameOpen(true);

    }

    const handleNameClose = () => {
        updChar([{k: 'name', v: newName}, {k: 'pname', v: newPName}]);
        setNameOpen(false)
    }


    return <Fragment>
        <Dialog open={nameOpen}>
            <DialogTitle>Name</DialogTitle>
            <DialogContent>
                <TextField InputLabelProps={{shrink: true}}
                           defaultValue={s_char.value.name}
                           variant="standard"
                           label="Name:"
                           onChange={(event) => setNewName(event.target.value)}
                />
                <TextField InputLabelProps={{shrink: true}}
                           defaultValue={s_char.value.name}
                           variant="standard"
                           label="Public Name:"
                           onChange={(event) => setNewPName(event.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleNameClose()}>ok</Button>
                <Button onClick={() => setNameOpen(false)}>abbruch</Button>
            </DialogActions>
        </Dialog>

        <Paper>
            <Stack direction="row" spacing={2} justifyContent="space-between">
                <div style={{padding: "0 10px", fontSize: '20px', fontWeight: 'bold'}}>
                    {s_char.value.name}
                    {s_char.value.pname && s_char.value.pname !== s_char.value.name ? ' (' + s_char.value.pname + ')' : null}
                    <IconButton onClick={handleNameOpen}><EditIcon/></IconButton>
                </div>

                <div style={{
                    color: 'white',
                    fontSize: 16,
                    padding: 8,
                    backgroundColor: s_char_tot.value ? 'red' : s_char_bewusstlos.value ? 'orange' : 'transparent',
                }}>
                    {s_char_tot.value ? 'TOT' : s_char_bewusstlos.value ? 'bewusstlos' : ''}
                </div>

                <CharRace/>{sl ? <><CharNSC/><CharVisible/></> : null}
            </Stack>
        </Paper>
    </Fragment>

}

export default CharName;